  /**
  * @description: 创建Vuex.Store实例保存到变量store中
  * @author: lzc
  * @createTime: lzc(2021-07-13)
  * @updateTime: name(xxxx-xx-xx)
  */

//引入vue
import Vue from 'vue'
//引入vuex
import Vuex from 'vuex'

import getters from './getters'

import permission from './modules/permission'

//使用vuex
Vue.use(Vuex)

//创建Vuex存储实例
const store = new Vuex.Store({
  state:{
    token:sessionStorage.getItem('accessToken'), 
    roles:sessionStorage.getItem('roles'),
  },
  modules:{
    permission
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js